import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('bfi_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err?.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('bfi_token');
      localStorage.removeItem('bfi_user');
      if (window.location.pathname.startsWith('/dashboard') || window.location.pathname.startsWith('/admin')) {
        window.location.href = '/connexion';
      }
    }
    return Promise.reject(err);
  }
);

export function setSession(token, user) {
  localStorage.setItem('bfi_token', token);
  localStorage.setItem('bfi_user', JSON.stringify(user));
}
export function clearSession() {
  localStorage.removeItem('bfi_token');
  localStorage.removeItem('bfi_user');
}
export function getSession() {
  const token = localStorage.getItem('bfi_token');
  const userStr = localStorage.getItem('bfi_user');
  let user = null;
  try { user = userStr ? JSON.parse(userStr) : null; } catch (e) { user = null; }
  return { token, user };
}
